var _path, _rect, _path2, _rect2, _rect3, _rect4, _path3, _rect5, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQrExtraRoundedSquares(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5 26.25C37.5 24.1789 35.8211 22.5 33.75 22.5C31.6789 22.5 30 24.1789 30 26.25V30V32.5C30 35.2614 32.2386 37.5 35 37.5H37.5H45H48.75C50.8211 37.5 52.5 35.8211 52.5 33.75C52.5 31.6789 50.8211 30 48.75 30H45H41.25C39.1789 30 37.5 28.3211 37.5 26.25Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 52.5,
    y: 22.5,
    width: 7.5,
    height: 7.5,
    rx: 3.75,
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 3.75C60 1.67893 58.3211 0 56.25 0C54.1789 0 52.5 1.67893 52.5 3.75C52.5 5.82107 50.8211 7.5 48.75 7.5C46.6789 7.5 45 9.17893 45 11.25V15V18.75C45 20.8211 46.6789 22.5 48.75 22.5C50.8211 22.5 52.5 20.8211 52.5 18.75C52.5 16.6789 54.1789 15 56.25 15C58.3211 15 60 13.3211 60 11.25V7.5V3.75Z",
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 52.5,
    width: 7.5,
    height: 7.5,
    rx: 3.75,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 22.5,
    y: 52.5,
    width: 7.5,
    height: 7.5,
    rx: 3.75,
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 45,
    width: 7.5,
    height: 7.5,
    rx: 3.75,
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45 48.75C45 46.6789 46.6789 45 48.75 45H52.5H55C57.7614 45 60 47.2386 60 50V52.5V56.25C60 58.3211 58.3211 60 56.25 60C54.1789 60 52.5 58.3211 52.5 56.25C52.5 54.1789 50.8211 52.5 48.75 52.5C46.6789 52.5 45 50.8211 45 48.75Z",
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 45,
    width: 7.5,
    height: 7.5,
    rx: 3.75,
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 26.25C22.5 24.1789 20.8211 22.5 18.75 22.5C16.6789 22.5 15 24.1789 15 26.25C15 28.3211 13.3211 30 11.25 30H7.5H3.75C1.67893 30 0 31.6789 0 33.75C0 35.8211 1.67893 37.5 3.75 37.5H7.5H10C12.7614 37.5 15 39.7386 15 42.5V45V48.75C15 50.8211 16.6789 52.5 18.75 52.5C20.8211 52.5 22.5 50.8211 22.5 48.75V45V37.5V30V26.25Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.75C0 1.67893 1.67893 0 3.75 0C5.82107 0 7.5 1.67893 7.5 3.75C7.5 5.82107 9.17893 7.5 11.25 7.5C13.3211 7.5 15 5.82107 15 3.75C15 1.67893 16.6789 0 18.75 0C20.8211 0 22.5 1.67893 22.5 3.75C22.5 5.82107 24.1789 7.5 26.25 7.5H30H33.75C35.8211 7.5 37.5 9.17893 37.5 11.25C37.5 13.3211 35.8211 15 33.75 15C31.6789 15 30 16.6789 30 18.75C30 20.8211 28.3211 22.5 26.25 22.5C24.1789 22.5 22.5 20.8211 22.5 18.75C22.5 16.6789 20.8211 15 18.75 15H15H11.25C9.17893 15 7.5 16.6789 7.5 18.75C7.5 20.8211 5.82107 22.5 3.75 22.5C1.67893 22.5 0 20.8211 0 18.75V15V7.5V3.75Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrExtraRoundedSquares);
export default __webpack_public_path__ + "static/media/qr-extra-rounded-squares.6db7a663555e86598c11c05fdbab0e3f.svg";
export { ForwardRef as ReactComponent };